export const CMS_GET = "CMS_GET"
export const CMS_DETAIL = "CMS_DETAIL"
export const CMS_UPDATE = "CMS_UPDATE"

